import { render, staticRenderFns } from "./ProgramInfoCard.vue?vue&type=template&id=1bb9003e"
import script from "./ProgramInfoCard.vue?vue&type=script&lang=ts"
export * from "./ProgramInfoCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports